import { runBuilderPromoCreateFlow } from './state-machine';

// Modal + multi-step modal controller.
// Uses data attributes so it stays generic across the landing/create/email modals.

export function initModals() {
    // Open
    $(document).on('click', '[data-bb-modal-open]', function (e) {
        e.preventDefault();
        const id = $(this).attr('data-bb-modal-open');
        openModal(id);
    });

    // Close (overlay, close button, cancel)
    $(document).on('click', '[data-bb-modal-close]', function (e) {
        e.preventDefault();
        const $modal = $(this).closest('[data-bb-modal]');
        closeModal($modal);
    });

    // Step navigation inside a modal
    $(document).on('click', '[data-bb-step-next]', function (e) {
        e.preventDefault();
        const target = $(this).attr('data-bb-step-next');
        if (validateStepFields($(this).parents('[data-bb-step]'))) {
            gotoStep($(this).closest('[data-bb-modal]'), target);
        }
    });

    $(document).on('click', '[data-bb-step-back]', function (e) {
        e.preventDefault();
        const target = $(this).attr('data-bb-step-back');
        gotoStep($(this).closest('[data-bb-modal]'), target);
    });

    // Esc closes any open modal
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $('[data-bb-modal]:visible').each(function () {
                closeModal($(this));
            });
        }
    });
    $('[name=email]').mask('A', {
        translation: { A: { pattern: /[\w@\-.+]/, recursive: true } },
    });
    $('[name=phone], [name=cellphone_number], [name=businessContactPhone]')
        .mask('000-000-0000', { placeholder: '___-___-____' });
    $('[name=phone], [name=cellphone_number], [name=businessContactPhone]').off('paste').on('paste', function (e) {
        e.preventDefault();
        let pastedData = e.originalEvent.clipboardData.getData('Text');
        let digits = pastedData.replace(/\D/g, '');
        if (digits.length > 10) {
            digits = digits.slice(-10);
        }
        $(this).val(digits);
        $(this).trigger('input');
    });

    // "Other" business type reveals a required description used by generation and plan routing.
    $(document).on('change', '[data-bb-preview-form] [name="work_type"]', function () {
        const $select = $(this);
        const isOther = String($select.find('option:selected').attr('data-bb-other-option') || '') === '1';
        const $field = $select.closest('[data-bb-preview-form]').find('[data-bb-other-business]');
        const $input = $field.find('[name="business_description"]');
        $field.toggleClass('bb-hidden', !isOther);
        $input.prop('required', isOther);
        if (!isOther) {
            $input.val('').removeClass('bb-field-error');
        }
    });

    initReferenceControls();
    initMigrationControls();


    try {
        const params = new URLSearchParams(window.location.search || '');
        if (params.get('start_new_preview') === '1' || params.get('clickthrough') === '1') openModal('bb-create-modal');
    } catch (e) {}

    $(document).on('click', '[data-bb-clickthrough-modal-next]', function (e) {
        e.preventDefault();
        const $modal = $('#bb-create-modal');
        if (!$modal.length) return;
        if ($modal.hasClass('bb-hidden')) {
            openModal('bb-create-modal');
            return;
        }

        const $current = $modal.find('[data-bb-step]').not('.bb-hidden').first();
        const currentStep = String($current.attr('data-bb-step') || '1');
        if (currentStep === '1') {
            gotoStep($modal, '2');
            return;
        }

        const $form = $modal.find('[data-bb-preview-form]').first();
        // An empty field must not hand the generator a roofing company's name.
        const businessName = String($form.find('[name="business_name"]').val() || '').trim();
        const url = new URL('/builder-promo/preview/create', window.location.origin);
        url.searchParams.set('clickthrough', '1');
        url.searchParams.set('business_name', businessName || 'your business');
        window.location.href = url.toString();
    });

    // Submit handler for preview modal: launch real generation, then open the dedicated progress page.
    $(document).on('submit', '[data-bb-preview-form]', function (e) {
        e.preventDefault();
        const $form = $(this);
        if (!validateStepFields($form.find('[data-bb-step="2"]'))) return;

        clearFormError($form);
        const payload = collectFormPayload($form);
        const $submitBtn = $form.find('[type="submit"], .bb-modal-submit-btn').prop('disabled', true);

        $.ajax({
            url: $form.attr('action') || '/builder-promo/preview/create',
            type: 'POST',
            data: payload.formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                Accept: 'application/json',
            },
            success(response) {
                if (response && response.redirect) {
                    window.location.href = response.redirect;
                    return;
                }

                if (response && response.draft_id && response.task_id) {
                    startModalGeneration($form, response, payload.values);
                    return;
                }

                $submitBtn.prop('disabled', false);
                showFormError($form, 'Website generation did not return a task. Please try again.');
            },
            error(xhr) {
                $submitBtn.prop('disabled', false);
                showFormError($form, errorMessage(xhr, 'An error occurred. Please try again.'));
            },
        });
    });
}

function collectFormPayload($form) {
    const formData = new FormData();
    const values = {};

    $form.find('input, select, textarea').each(function () {
        const $input = $(this);
        const input = this;
        const name = $input.attr('name');
        if (!name || $input.prop('disabled')) return;

        if ($input.is('[type="file"]')) {
            Array.prototype.forEach.call(input.files || [], function (file) {
                formData.append(name, file);
            });
            return;
        }

        let value = $input.val();
        if (name === 'design_reference_urls') {
            value = normalizeReferenceTextarea(value);
            $input.val(value);
        }

        if ($input.is(':checkbox')) {
            value = $input.is(':checked') ? '1' : '0';
        } else if ($input.is(':radio')) {
            if (!$input.is(':checked')) return;
        }

        formData.append(name, value == null ? '' : String(value));
        if (!name.endsWith('[]')) {
            values[name] = value;
        }
    });

    const captured = $form.data('bbCapturedReferenceImages') || [];
    captured.forEach(function (ref) {
        if (ref && ref.storage_path) {
            formData.append('design_reference_stored_paths[]', ref.storage_path);
        }
    });

    return { formData, values };
}

function startModalGeneration($form, response, formData) {
    const $modal = $form.closest('[data-bb-modal]');
    const $progressRoot = $modal.find('[data-bb-create-progress]');
    if (!$progressRoot.length) {
        if (response.redirect) window.location.href = response.redirect;
        return;
    }

    const statusUrl = String($progressRoot.attr('data-bb-status-url') || '').trim();
    const continueUrl = String($progressRoot.attr('data-bb-continue-url') || '').trim();
    const runUrl = String($progressRoot.attr('data-bb-run-url') || '').trim();
    const runDetailsUrl = String($progressRoot.attr('data-bb-run-details-url') || '').trim();
    const draftUrl = String($progressRoot.attr('data-bb-draft-url') || '').trim();
    const deleteRunUrl = String($progressRoot.attr('data-bb-delete-run-url') || '').trim();
    if (!statusUrl || !continueUrl) {
        if (response.redirect) window.location.href = response.redirect;
        return;
    }

    resetProgressModal($progressRoot, formData);
    $modal.find('.bb-modal__dialog').addClass('bb-modal__dialog--progress');
    gotoStep($modal, 'progress');

    runBuilderPromoCreateFlow($progressRoot, {
        draftId: response.draft_id,
        taskId: response.task_id,
        statusUrl,
        continueUrl,
        runUrl,
        runDetailsUrl,
        draftUrl,
        deleteRunUrl,
    });
}


function resetProgressModal($root, formData) {
    const businessName = String(formData.business_name || '').trim() || 'your business';
    $root.removeClass('is-finalized');
    $root.find('[data-bb-progress-business-name]').text(businessName);
    $root.find('[data-stage-eyebrow]').text('STAGE 1');
    $root.find('[data-stage-title]').text('Understanding your business');
    $root.find('[data-stage-body]').addClass('bb-hidden');
    $root.find('[data-stage-body="0"]').removeClass('bb-hidden');
    $root.find('[data-bb-create-error]').addClass('bb-hidden').text('');
    $root.find('[data-bb-when-finalized]').addClass('bb-hidden');
    $root.find('[data-bb-final-action]').addClass('bb-hidden');
    $root.find('[data-bb-final-link]').attr('href', '/builder-promo/preview');
    $root.find('[data-bb-final-message]').text('Your style preview is ready for review.');
    $root.find('[data-bb-progress-primary]').removeClass('bb-hidden').prop('disabled', true).text('Generating style preview...');
    $root.data('bbClickThroughMode', false).removeData('bbClickThroughIndex');
    $root.find('.bb-openai-progress-grid--legacy').removeClass('bb-hidden').attr('aria-hidden', 'false');
    $root.find('[data-bb-progress-fill]').css('width', '10%');
    $root.find('[data-bb-progress-pct]').text('10%');
    $root.find('[data-bb-status-message]').text('Queued concept generation...');
    $root.find('[data-bb-step-item]').removeClass('is-done is-active').first().addClass('is-active');
    $root.find('[data-bb-ai-run-card-wrap]').html('<div class="bb-ai-run-empty">Waiting for the run record...</div>');
    $root.find('[data-bb-ai-review-panel]').addClass('bb-hidden');
    $root.find('[data-bb-ai-details-modal]').addClass('bb-hidden').attr('aria-hidden', 'true');
}

function openModal(id) {
    const $modal = $('#' + id);
    if (!$modal.length) return;
    $modal.removeClass('bb-hidden');
    $('body').css('overflow', 'hidden');
}

function closeModal($modal) {
    if (!$modal || !$modal.length) return;
    $modal.addClass('bb-hidden');
    $('body').css('overflow', '');
}

function gotoStep($modal, stepName) {
    $modal.find('[data-bb-step]').addClass('bb-hidden');
    $modal.find('[data-bb-step="' + stepName + '"]').removeClass('bb-hidden');
}

/**
 * Validate fields on a specific step inside a modal.
 * @param {jQuery} step - jQuery object for the step pane
 * @returns {boolean} - true if valid, false otherwise
 */
function validateStepFields(step) {
    let isValid = true;

    const $step = step;

    $step.find('input[required], textarea[required], select[required]').each(function () {
        const $field = $(this);

        $field.removeClass('bb-field-error');

        if (
            ($field.is('input[type="checkbox"]') && !$field.is(':checked')) ||
            ($field.is('input[type="radio"]')) && !$field.closest('form').find('input[name="' + $field.attr('name') + '"]:checked').length ||
            ($field.val() === '' || $field.val() === null)
        ) {
            isValid = false;
            $field.addClass('bb-field-error');
        }
    });

    if (!isValid) {
        if ($step.find('.bb-step-error-msg').length === 0) {
            $step.prepend('<div class="bb-step-error-msg">Please fill in all required fields.</div>');
        }
    } else {
        $step.find('.bb-step-error-msg').remove();
    }

    return isValid;
}


function initReferenceControls() {
    $('[data-bb-preview-form]').each(function () {
        const $form = $(this);
        const $dropzone = $form.find('[data-bb-reference-dropzone]');
        const $fileInput = $form.find('[data-bb-reference-images]');
        const $files = $form.find('[data-bb-reference-files]');
        const $urls = $form.find('[data-bb-reference-urls]');
        const captureUrl = String($form.attr('data-bb-reference-capture-url') || '').trim();
        const maxReferences = 6;
        let pendingCaptures = {};
        let captureTimer = null;

        if (!$fileInput.length || !$files.length) return;
        $form.data('bbCapturedReferenceImages', []);

        function captured() {
            return $form.data('bbCapturedReferenceImages') || [];
        }

        function setCaptured(next) {
            $form.data('bbCapturedReferenceImages', next || []);
        }

        function currentFiles() {
            return Array.prototype.slice.call($fileInput[0].files || []);
        }

        function setFiles(files) {
            const dt = new DataTransfer();
            const available = Math.max(0, maxReferences - captured().length - Object.keys(pendingCaptures).length);
            files.slice(0, available).forEach(function (file) {
                dt.items.add(file);
            });
            $fileInput[0].files = dt.files;
            renderReferences();
        }

        function totalCount() {
            return currentFiles().length + captured().length + Object.keys(pendingCaptures).length;
        }

        function referenceChip(label, opts) {
            opts = opts || {};
            const $chip = $('<div class="bb-reference-chip"></div>');
            const $thumb = $('<button type="button" class="bb-reference-chip__thumb"></button>');
            if (opts.loading) {
                $thumb.append('<span class="bb-reference-spinner"></span>');
            } else if (opts.url) {
                $thumb.append($('<img alt="">').attr('src', opts.url));
            } else {
                $thumb.append('<span></span>');
            }
            const $name = $('<span class="bb-reference-chip__name"></span>').text(label || 'Reference');
            const $remove = $('<button type="button" class="bb-reference-chip__remove" aria-label="Remove">&times;</button>');
            if (opts.removeFile !== undefined) $remove.attr('data-bb-remove-reference-file', String(opts.removeFile));
            if (opts.removeCaptured) $remove.attr('data-bb-remove-reference-captured', opts.removeCaptured);
            if (opts.removePending) $remove.attr('data-bb-remove-reference-pending', opts.removePending);
            $chip.append($thumb, $name, $remove);
            return $chip;
        }

        function renderReferences() {
            $files.empty();
            Object.keys(pendingCaptures).forEach(function (key) {
                $files.append(referenceChip('Capturing ' + hostLabel(pendingCaptures[key]), {
                    loading: true,
                    removePending: key,
                }));
            });
            captured().forEach(function (ref) {
                $files.append(referenceChip((ref.is_screenshot ? 'Screenshot ' : 'Reference ') + hostLabel(ref.source_url), {
                    url: ref.public_url,
                    removeCaptured: ref.id,
                }));
            });
            currentFiles().forEach(function (file, idx) {
                const url = URL.createObjectURL(file);
                $files.append(referenceChip(file.name || 'Uploaded image', { url: url, removeFile: idx }));
            });
            $dropzone.toggleClass('is-full', totalCount() >= maxReferences);
        }

        function scheduleUrlCapture() {
            if (!captureUrl || !$urls.length) return;
            if (captureTimer) clearTimeout(captureTimer);
            captureTimer = setTimeout(function () {
                captureTimer = null;
                const urls = normalizeReferenceTextarea($urls.val()).split(/\r?\n/).filter(Boolean);
                urls.forEach(queueUrlCapture);
            }, 500);
        }

        function queueUrlCapture(url) {
            if (!captureUrl || totalCount() >= maxReferences) return;
            const normalized = normalizeHttpUrl(url);
            if (!normalized) return;
            const key = normalized.toLowerCase();
            const alreadyCaptured = captured().some(function (ref) {
                return String(ref.source_url || '').toLowerCase() === key;
            });
            if (alreadyCaptured || pendingCaptures[key]) return;

            pendingCaptures[key] = normalized;
            renderReferences();
            postJson(captureUrl, { url: normalized })
                .then(function (json) {
                    if (!pendingCaptures[key]) {
                        renderReferences();
                        return;
                    }
                    delete pendingCaptures[key];
                    if (!json || !json.storage_path) {
                        renderReferences();
                        return;
                    }
                    const refs = captured();
                    refs.push({
                        id: 'cap-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
                        storage_path: json.storage_path,
                        public_url: json.public_url,
                        source_url: json.source_url || normalized,
                        is_screenshot: !!json.is_screenshot,
                    });
                    setCaptured(refs.slice(0, maxReferences));
                    renderReferences();
                })
                .catch(function () {
                    delete pendingCaptures[key];
                    renderReferences();
                });
        }

        $fileInput.on('change', function () {
            setFiles(currentFiles());
        });

        $dropzone.on('dragover', function (e) {
            e.preventDefault();
            $dropzone.addClass('is-dragover');
        }).on('dragleave drop', function (e) {
            e.preventDefault();
            $dropzone.removeClass('is-dragover');
            if (e.type !== 'drop' || !e.originalEvent.dataTransfer) return;
            const incoming = Array.prototype.filter.call(e.originalEvent.dataTransfer.files || [], function (file) {
                return String(file.type || '').indexOf('image/') === 0;
            });
            setFiles(currentFiles().concat(incoming));
        });

        $files.on('click', '[data-bb-remove-reference-file]', function () {
            const removeIdx = Number($(this).attr('data-bb-remove-reference-file'));
            setFiles(currentFiles().filter(function (_, idx) { return idx !== removeIdx; }));
        });
        $files.on('click', '[data-bb-remove-reference-captured]', function () {
            const id = String($(this).attr('data-bb-remove-reference-captured'));
            setCaptured(captured().filter(function (ref) { return String(ref.id) !== id; }));
            renderReferences();
        });
        $files.on('click', '[data-bb-remove-reference-pending]', function () {
            delete pendingCaptures[String($(this).attr('data-bb-remove-reference-pending'))];
            renderReferences();
        });

        $urls.on('input paste', function () {
            setTimeout(scheduleUrlCapture, 0);
        });

        renderReferences();
    });
}

function initMigrationControls() {
    $('[data-bb-preview-form]').each(function () {
        const $form = $(this);
        const discoverUrl = String($form.attr('data-bb-migration-discover-url') || '').trim();
        const verifyUrl = String($form.attr('data-bb-migration-verify-url') || '').trim();
        const state = { sourceWebsite: '', discovered: [], selected: [], maxSelectable: 20 };

        const $url = $form.find('[data-bb-migration-url]');
        const $confirm = $form.find('[data-bb-migration-confirm]');
        const $hidden = $form.find('[data-bb-migration-pages]');
        const $status = $form.find('[data-bb-migration-status]');
        const $summary = $form.find('[data-bb-migration-summary]');
        const $panel = $form.find('[data-bb-migration-pages-panel]');
        const $list = $form.find('[data-bb-migration-list]');
        const $counter = $form.find('[data-bb-migration-counter]');
        const $clear = $form.find('[data-bb-migration-clear]');

        if (!discoverUrl || !$url.length) return;

        function setStatus(message, isError) {
            $status.text(message || '').toggleClass('is-error', !!isError);
        }

        function syncHidden() {
            $hidden.val(JSON.stringify(state.selected));
            $counter.text(state.selected.length + ' of ' + state.maxSelectable + ' selected');
            $summary.toggleClass('bb-hidden', state.selected.length === 0);
            $clear.toggleClass('bb-hidden', state.selected.length === 0);
            if (state.selected.length) {
                $summary.html('<strong>' + state.selected.length + '</strong> page' + (state.selected.length === 1 ? '' : 's') + ' selected for migration from <strong>' + escapeHtml(state.sourceWebsite || $url.val()) + '</strong>.');
            }
        }

        function renderPages() {
            $panel.removeClass('bb-hidden');
            $list.empty();
            if (!state.discovered.length) {
                $list.append('<div class="bb-migration__empty">No live pages found.</div>');
                syncHidden();
                return;
            }
            state.discovered.forEach(function (page, index) {
                const checked = state.selected.indexOf(page.url) !== -1;
                const $row = $('<label class="bb-migration-page"></label>');
                const $box = $('<input type="checkbox">').attr('data-index', index).prop('checked', checked);
                const $text = $('<span></span>');
                $text.append($('<strong></strong>').text(page.path || page.url));
                if (page.title) $text.append($('<small></small>').text(page.title));
                $row.append($box, $text);
                $list.append($row);
            });
            syncHidden();
        }

        $list.on('change', 'input[type="checkbox"]', function () {
            const page = state.discovered[Number($(this).attr('data-index'))];
            if (!page) return;
            const existing = state.selected.indexOf(page.url);
            if (this.checked && existing === -1) {
                if (state.selected.length >= state.maxSelectable) {
                    this.checked = false;
                    return;
                }
                state.selected.push(page.url);
            } else if (!this.checked && existing !== -1) {
                state.selected.splice(existing, 1);
            }
            syncHidden();
        });

        $form.find('[data-bb-migration-find]').on('click', function () {
            const rawUrl = String($url.val() || '').trim();
            if (!rawUrl) {
                setStatus('Enter your website address first.', true);
                return;
            }
            if (!$confirm.is(':checked')) {
                setStatus('Please confirm you own this website and have permission.', true);
                return;
            }
            const $btn = $(this).prop('disabled', true);
            setStatus('Reading your sitemap and checking which pages are live...');
            postJson(discoverUrl, {
                website_url: rawUrl,
                confirmed_ownership: true,
            }).then(function (json) {
                state.sourceWebsite = json.source_website || rawUrl;
                state.discovered = Array.isArray(json.pages) ? json.pages : [];
                state.maxSelectable = json.max_selectable || 20;
                state.selected = state.selected.filter(function (selectedUrl) {
                    return state.discovered.some(function (page) { return page.url === selectedUrl; });
                });
                setStatus(state.discovered.length + ' live page' + (state.discovered.length === 1 ? '' : 's') + ' found.');
                renderPages();
            }).catch(function (error) {
                setStatus(error.message || 'Could not read that website.', true);
            }).always(function () {
                $btn.prop('disabled', false);
            });
        });

        $clear.on('click', function () {
            state.selected = [];
            renderPages();
        });

        $form.find('[data-bb-migration-manual-add]').on('click', function () {
            if (!verifyUrl) return;
            const $manualInput = $form.find('[data-bb-migration-manual-url]');
            const $manualStatus = $form.find('[data-bb-migration-manual-status]');
            const pageUrl = String($manualInput.val() || '').trim();
            if (!pageUrl) {
                $manualStatus.text('Enter the page address first.').addClass('is-error');
                return;
            }
            const $btn = $(this).prop('disabled', true);
            $manualStatus.text('Checking that the page is live...').removeClass('is-error');
            postJson(verifyUrl, {
                website_url: state.sourceWebsite || $url.val(),
                page_url: pageUrl,
            }).then(function (json) {
                const page = json.page || {};
                if (!page.url) return;
                if (!state.discovered.some(function (item) { return item.url === page.url; })) {
                    state.discovered.unshift(page);
                }
                if (state.selected.indexOf(page.url) === -1 && state.selected.length < state.maxSelectable) {
                    state.selected.push(page.url);
                }
                $manualInput.val('');
                $manualStatus.text('Added and selected.').removeClass('is-error');
                renderPages();
            }).catch(function (error) {
                $manualStatus.text(error.message || 'Could not check that page.').addClass('is-error');
            }).always(function () {
                $btn.prop('disabled', false);
            });
        });
    });
}

function postJson(url, data) {
    return $.ajax({
        url: url,
        type: 'POST',
        data: JSON.stringify(data || {}),
        contentType: 'application/json',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            Accept: 'application/json',
        },
    });
}

function normalizeReferenceTextarea(value) {
    const seen = {};
    return String(value || '').split(/\r?\n/).map(normalizeHttpUrl).filter(function (url) {
        if (!url) return false;
        const key = url.toLowerCase();
        if (seen[key]) return false;
        seen[key] = true;
        return true;
    }).join('\n');
}

function normalizeHttpUrl(value) {
    let url = String(value || '').trim();
    if (!url) return '';
    if (!/^https?:\/\//i.test(url) && /^[\w.-]+\.[a-z]{2,}/i.test(url)) {
        url = 'https://' + url;
    }
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
        return parsed.href;
    } catch (e) {
        return '';
    }
}

function hostLabel(url) {
    try {
        return new URL(url).hostname.replace(/^www\./i, '');
    } catch (e) {
        return 'reference';
    }
}

function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char];
    });
}

function showFormError($form, message) {
    let $error = $form.find('[data-bb-preview-form-error]');
    if (!$error.length) {
        $error = $('<div class="bb-preview-form-error" data-bb-preview-form-error></div>');
        $form.find('[data-bb-step="2"] .bb-modal__body').prepend($error);
    }
    $error.text(message || 'An error occurred. Please try again.').removeClass('bb-hidden');
}

function clearFormError($form) {
    $form.find('[data-bb-preview-form-error]').addClass('bb-hidden').text('');
}

function errorMessage(xhr, fallback) {
    if (xhr && xhr.responseJSON) {
        if (xhr.responseJSON.message) return xhr.responseJSON.message;
        if (xhr.responseJSON.error) return xhr.responseJSON.error;
    }
    return fallback;
}
